import NumericFormatInput, { NumericFormatInputPropsType } from "./NumericFormatInput";

type CurrencyInputPropsType = {
  currency?: string;
  currencyPosition?: "before" | "after";
} & Omit<NumericFormatInputPropsType, "prefix" | "suffix" | "decimalScale" | "fixedDecimalScale">;

export default function CurrencyInput(props: CurrencyInputPropsType) {
  const { currency = "€", currencyPosition = "after", ...numericFormatInputProps } = props;

  const prefix = currencyPosition === "before" ? `${currency} ` : "";
  const suffix = currencyPosition === "after" ? ` ${currency}` : "";

  return (
    <NumericFormatInput
      prefix={prefix}
      suffix={suffix}
      decimalScale={2}
      fixedDecimalScale={true}
      {...numericFormatInputProps}
    />
  );
}
